module.exports = "<ng2-pdfjs-viewer *ngIf=\"viewerFolder\" [pdfSrc]=\"pdfSrc\" [viewerFolder]=\"viewerFolder\" page=\"1\"></ng2-pdfjs-viewer>";